module.exports = __webpack_public_path__ + "img/729.f6987859.png";